import { createBrowserRouter, Navigate } from "react-router-dom";
import { ProtectedRoute } from "@kinde-oss/kinde-auth-react/react-router";

import Login from "../account/login";
import Home from "../home";
import Layout from "../hoc/layout";
import Entries from "../entries";
import ErrorBoundary from "../errorBoundary";
import ErrorPage from "./errorPage";
import Players from "../players";
import Player from "../players/player";
import MyRecord from "../myrecord";
import AdminLayout from "../admin/AdminLayout";
import AdminEntries from "../admin/AdminEntries";
import Flags from "../admin/Flags";
import AdminActions from "../admin/AdminActions";
import AdminTaskList from "../admin/TaskList";
import Organisations from "../admin/Organisations";
import Clubs from "../admin/Clubs";
import RankingSetup from "../admin/RankingSetup";
import MemberImport from "../admin/MemberImport";
import ApiKeys from "../admin/ApiKeys";
import Exports from "../admin/Exports";
import PlayersAdmin from "../admin/PlayersAdmin";
import AiAssistant from "../admin/AiAssistant";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "my-record",
        element: (
          <ErrorBoundary>
            <ProtectedRoute>
              <MyRecord />
            </ProtectedRoute>
          </ErrorBoundary>
        ),
      },
      {
        path: "pba-log",
        element: <Home />,
      },
      {
        path: "players",
        element: (
          <ErrorBoundary>
            <ProtectedRoute has={{ roles: ["admin"] }}>
              <Players />
            </ProtectedRoute>
          </ErrorBoundary>
        ),
      },
      {
        path: "players/:bsa_number",
        element: (
          <ErrorBoundary>
            <ProtectedRoute has={{ roles: ["admin"] }}>
              <Player />
            </ProtectedRoute>
          </ErrorBoundary>
        ),
      },
      {
        path: "entries",
        element: (
          <ErrorBoundary>
            <ProtectedRoute>
              <Entries />
            </ProtectedRoute>
          </ErrorBoundary>
        ),
      },
      {
        path: "admin",
        element: (
          <ErrorBoundary>
            <ProtectedRoute has={{ roles: ["admin"] }}>
              <AdminLayout />
            </ProtectedRoute>
          </ErrorBoundary>
        ),
        children: [
          { index: true, element: <Navigate to="entries" replace /> },
          { path: "entries", element: <AdminEntries /> },
          { path: "flags", element: <Flags /> },
          { path: "actions", element: <AdminActions /> },
          { path: "tasks", element: <AdminTaskList /> },
          { path: "organisations", element: <Organisations /> },
          { path: "clubs", element: <Clubs /> },
          { path: "ranking-setup", element: <RankingSetup /> },
          { path: "member-import", element: <MemberImport /> },
          { path: "api-keys", element: <ApiKeys /> },
          { path: "exports", element: <Exports /> },
          { path: "players", element: <PlayersAdmin /> },
          { path: "ai", element: <AiAssistant /> },
        ],
      },
    ],
  },
  {
    path: "/login",
    element: (
      <ErrorBoundary>
        <Login />
      </ErrorBoundary>
    ),
  },
]);
